<template>
  <v-card
    class="d-flex flex-column flex-sm-row align-center justify-space-between pa-5 my-6"
    style="background: linear-gradient(-90deg, #02203d, #001527)"
    flat
  >
    <div class="white--text text-center text-sm-left mb-3 mb-sm-0">
      <div class="text-h6 font-weight-bold">
        Want to see how your resume scores?
      </div>
      <div>Analyze your resume with FaangIT.com and get instant feedback.</div>
    </div>
    <v-btn color="primary" large to="/evaluate-ai"> Analyze my resume </v-btn>
  </v-card>
</template>

<script>
export default {
  name: "ResumeCtaBanner",
};
</script>
